import { z } from 'zod';

export const fetchVaultFilesResponseSchema = z.object({
  videoFile: z.string().nullable(),
  videoPath: z.string().nullable(),
  srtFile: z.string().nullable(),
  srtPath: z.string().nullable(),
});

export type IFetchVaultFilesResponse = z.infer<typeof fetchVaultFilesResponseSchema>;
